import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
import { costs, faqs } from '../data/copy';
import { purchases } from '../data/testimonials';
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-20" data-mp="3pmbrfc9mo6zq">
        <div className="mx-auto max-w-3xl text-center" data-id="element-21" data-mp="3brj8e3uj48oe">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-22" data-mp="3gkcccpi6bczf" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-23" data-mp="31v6g9aemu2vr">
            GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-24" data-mp="36ussbgiq5d2z">
            <p className="text-slate-300" data-id="element-25" data-mp="2svaygmqkn9mr">Seguís las fases. Ordenás las comidas. Registrás lo que pasa.</p>
            <p className="mt-4 text-slate-300" data-id="element-26" data-mp="2wujs7rlm37ib">
              Si en 30 días no es lo que esperabas, te devolvemos el 100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-27" data-mp="2ftmq9xzzomr5">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-28" data-mp="2pq9ackkhr9s4">sin formularios, sin drama.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-29" data-mp="2kqmv65l3rjgo">Tasa de devoluciones: menos del 1%.</p>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-30" data-mp="1x23pzyxcnmst">
        <div className="mx-auto max-w-3xl" data-id="element-31" data-mp="1s2h7pb2nzgd5">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-32" data-mp="1s3sfrn357aa2">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-33" data-mp="26sydf6mc0sfu">
            {faqs.map((faq, index) => {
            const panelId = `faq-panel-${index}`;
            const isOpen = open === index;
            return <div key={faq.question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-34" data-mp="19br5lokx3xlc" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-35" data-mp="1yzmxh55hhiwl">
                    <span data-id="element-36" data-mp="1g1iw4wvu8o5c">{faq.question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-37" data-mp="1g2u0axt73xwz" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-38" data-mp="1tyfnr0js69na">
                    {isOpen && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-39" data-mp="30iyqqyn7042n">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-40" data-mp="k1qz6y1wmr74">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-41" data-mp="14ps97osih0j">
      <div className="mx-auto max-w-4xl" data-id="element-42" data-mp="3sahhm4uqtpma">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-43" data-mp="3sbj18xptrkfm">
          ⚖️ ¿CUÁNTO CUESTA NO TENER EL SISTEMA?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-44" data-mp="1qj4ftoo2nxug">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-45" data-mp="1yjalyslv2lhl">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-46" data-mp="1olw9t56z0iv3">
                ×
              </span>
              {item}
            </p>)}
        </div>
        <p className="mt-12 text-center text-xl font-bold" data-id="element-47" data-mp="1tmafigl3ngpy">El próximo lunes puede ser diferente.</p>
        <p className="mx-auto mt-5 max-w-3xl text-center font-display text-xl font-bold italic text-brand-light sm:text-2xl" data-id="element-48" data-mp="1fr86vlovbd9g">
          “Tu intestino no está roto. Está esperando el orden correcto.” 🌿
        </p>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-49" data-mp="d9zri33hiaoh">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-50" data-mp="r8zg5aqzypkn">
          PROTOCOLO RESCATE SIBO™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-51" data-mp="1152mkssvtade">
          El sistema de 5 fases para tratar el sobrecrecimiento bacteriano y recuperar una digestión
          previsible.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-52" data-mp="19y5vqowhv128">
          Porque tu intestino no está roto. Está esperando el orden correcto.
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-53" data-mp="1jw2b5swgsi65">
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-54" data-mp="1eyjzhur2boug">
            📧 soportebiomalivido@gmail.com
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="https://www.instagram.com/biomalivido/" target="_blank" rel="noreferrer" data-id="element-55" data-mp="gmhbb9q91xom">
            📲 @biomalivido
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="https://www.biomalivido.com" target="_blank" rel="noreferrer" data-id="element-56" data-mp="vbn86r1m7btc">
            🌐 biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-57" data-mp="19ad78c7zvlkc">
          © PROTOCOLO RESCATE SIBO™ 2026 — Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-58" data-mp="364ge4x8ic9gy">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-59" data-mp="3b1q90seo1dc6">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-60" data-mp="2otunt7fqr50n">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="3mhl743i1z0co" />
              Acceso confirmado
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-62" data-mp="3hjjpzo46tb3u">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-63" data-mp="3cl01bfy7ll7s">adquirió Protocolo Rescate SIBO™</p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-64" data-mp="38haccpdmh1m8">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}